import { InjectionToken } from '@angular/core';

import { ShellApi } from './shell-api.interface';

export const SHELL_API = new InjectionToken<ShellApi>('SHELL_API');
